export function CampermanGapFillerIntegrationScreen() {
  return (
    <div>{`That's it! We'll pull from the gap filler spreadsheet every hour`}</div>
  );
}
